import { Directive, ElementRef, Input } from '@angular/core';

import { DragController } from '@anjuna/core';

/**
 * @description A wrapper around the HTML 5 Drag API.
 */
@Directive({
    selector: '[anjDraggable]'
})
export class DraggableDirective {

    /**
     * @description Binds to arbitrary data to be passed via anjDroppable's onDrop event emitter.
     */
    @Input() public anjDraggable: any;

    private controller: DragController;
    private dataFn = () => this.getData();

    constructor(private element: ElementRef) {
        this.controller = new DragController(this.element.nativeElement, this.dataFn).connect();
    }

    private getData(): any {
        return this.anjDraggable;
    }
}
